<template>
  <v-container>
    <navbar :links="['login', 'passwordReset']" />
    <v-layout
      row
      justify-center
      class="mt-5"
    >
      <v-flex sm6>
        <v-layout
          v-if="submitted"
          row
        >
          <v-icon
            color="success"
            x-large
            class="mr-4"
          >
            check
          </v-icon>
          <div class="subheading">
            {{ $t('passwordResetSuccessGeneric') }}
          </div>
        </v-layout>
        <v-layout
          v-else
          column
        >
          <div class="title mb-3">
            {{ $t('passwordReset') }}
          </div>
          <div class="subheading grey--text text--darken-2 mb-4">
            {{ $t('passwordResetHint') }}
          </div>
          <v-text-field
            ref="email"
            v-model="email"
            :label="$t('email')"
            type="email"
            prepend-icon="mail"
            :rules="[validateEmail]"
            @keyup.enter="requestPasswordReset(email)"
          />
          <v-layout row>
            <v-spacer />
            <btn-ok
              round
              :icon="'send'"
              :loading="busy"
              :disabled="!isValidEmail(email)"
              label-with-icon
              :label="$t('submit')"
              @click="requestPasswordReset(email)"
            />
          </v-layout>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {SUPPORT_HOTLINE} from '@/store';

import BtnOk from '@/components/ButtonOk';
import Navbar from '@/components/Navbar';

export default {
  name: 'Passwordforgotten',
  components: {
    BtnOk,
    Navbar,
  },
  data() {
    return {
      busy: false,
      email: '',
      supportHotline: SUPPORT_HOTLINE,
      submitted: false,
    };
  },
  mounted() {
    if (this.$refs.email) {
      this.$refs.email.focus();
    }
  },
  methods: {
    isValidEmail(email) {
      if (email.trim() === '') {
        return;
      }
      // See: https://stackoverflow.com/questions/46155
      const regexUnicodeEmail =
        /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      return regexUnicodeEmail.test(email);
    },
    validateEmail(email) {
      if (email.trim() === '') {
        return '';
      }
      if (!this.isValidEmail(email)) {
        return this.$t('invalidEmail');
      }
      return true;
    },
    requestPasswordReset(email) {
      email = email.trim();

      this.busy = true;
      this.$api
        .requestForgotPasswordLink(email)
        .then((response) => {
          this.reset();
          this.submitted = true;

          let message = this.$t('passwordResetSuccess');
          message = message.replace('{{ email }}', email);
          this.$bus.$emit('alert-success', {
            message: message,
            translate: false,
            timeout: 20000,
            hjsuppress: true,
          });
        })
        .catch((error) => {
          this.busy = false;
          this.$bus.$emit('alert-error', {
            message: 'genericFailedInfo',
            translate: true,
            timeout: 8000,
          });
        });
    },
    resetErrors() {
      this.showNoUserForEmail = false;
      this.showDuplicateEmailWarning = false;
    },
    reset() {
      this.resetErrors();
      this.busy = false;
      this.email = '';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/PasswordForgotten.vue